import { PriorityLevel } from '@sib/api';

export const priorityColors: Record<PriorityLevel, string> = {
  [PriorityLevel.Low]: 'hsl(var(--info-subtle))',
  [PriorityLevel.Medium]: 'hsl(var(--warning-subtle))',
  [PriorityLevel.High]: 'hsl(var(--accent-pink-soft))',
};
